var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75238 3.74921C5.88483 3.61746 6.06687 3.54167 6.25317 3.54167H10.7468C10.9331 3.54167 11.1152 3.61746 11.2476 3.74921L12.4567 4.95833H4.54325L5.75238 3.74921ZM14.2524 4.75079L12.2492 2.74762C11.8483 2.346 11.3142 2.125 10.7468 2.125H6.25317C5.68579 2.125 5.15171 2.346 4.75079 2.74762L2.74762 4.75079C2.346 5.15171 2.125 5.68579 2.125 6.25387V12.75C2.125 13.9216 3.07842 14.875 4.25 14.875H12.75C13.9216 14.875 14.875 13.9216 14.875 12.75V6.25387C14.875 5.68579 14.654 5.15171 14.2524 4.75079Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7493 13.4583H4.24935C3.85835 13.4583 3.54102 13.1403 3.54102 12.75V6.375H13.4577V12.75C13.4577 13.1403 13.1403 13.4583 12.7493 13.4583Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6243 7.7915C10.2326 7.7915 9.91602 8.10884 9.91602 8.49984C9.91602 9.28113 9.28064 9.9165 8.49935 9.9165C7.71806 9.9165 7.08268 9.28113 7.08268 8.49984C7.08268 8.10884 6.76606 7.7915 6.37435 7.7915C5.98264 7.7915 5.66602 8.10884 5.66602 8.49984C5.66602 10.0624 6.93677 11.3332 8.49935 11.3332C10.0619 11.3332 11.3327 10.0624 11.3327 8.49984C11.3327 8.10884 11.0161 7.7915 10.6243 7.7915Z",
    fill: "#E3282A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.e085e743a95090ed4d1f4346bffd64b7.svg";
export { ForwardRef as ReactComponent };